import { t } from "@lingui/core/macro"
import { Outlet, createFileRoute } from "@tanstack/react-router"
import { FileBarChart } from "lucide-react"
import { PageHeader } from "@/components/ui/PageHeader"

export const Route = createFileRoute("/(authenticated)/reports")({
  component: ReportsLayout,
})

function ReportsLayout() {
  return (
    <div className="mx-auto max-w-6xl">
      <PageHeader
        title={t`Reports`}
        icon={<FileBarChart className="h-7 w-7" />}
        description={t`Generate and export reports across all your stores.`}
      />
      <Outlet />
    </div>
  )
}
